import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { BufferForChangeId, ChangeId, IssueAdjustmentsState } from '../../../types';
import { setAppErrors } from '../../app-errors';
import type { ErrorCode } from '../../types';
import type { ConflictsGroupedByAppId } from '../types';
import { getConflictErrorGroups } from '../utils';

/*
 * We need to persist the information that some errors happened to decide if success SLO event should be sent.
 * General UIM errors kept in `error` state property are reset after showing the flag.
 */
export const addBufferError =
	(errorCode: ErrorCode) =>
	({ setState, getState }: StoreActionApi<IssueAdjustmentsState>) => {
		const bufferErrors: ErrorCode[] = getState().bufferErrors || [];

		setState({
			bufferErrors: [...bufferErrors, errorCode],
		});
	};

export const resetBufferErrors =
	() =>
	({ setState }: StoreActionApi<IssueAdjustmentsState>) => {
		setState({
			bufferErrors: null,
		});
	};

export const setAppConflictErrors =
	(changeId: ChangeId, bufferForChangeId: BufferForChangeId, conflicts: ConflictsGroupedByAppId) =>
	({ dispatch, getState }: StoreActionApi<IssueAdjustmentsState>) => {
		const appIds = Object.keys(bufferForChangeId);
		const lifecycleHook = changeId.startsWith('onInit') ? 'onInit' : 'onChange';

		const errorGroupsMap = getConflictErrorGroups({
			appIds,
			conflicts,
			formData: getState().formData || {},
			lifecycleHook,
		});

		Object.entries(errorGroupsMap).forEach(([appId, errorGroup]) => {
			dispatch(
				setAppErrors({
					errors: errorGroup,
					appId,
				}),
			);
		});
	};
